import { render, staticRenderFns } from "./AllInvestors.vue?vue&type=template&id=2eb728f8"
import script from "./AllInvestors.vue?vue&type=script&lang=js"
export * from "./AllInvestors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports